import { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';
import confettiAnimation from './confetti-burst.json'; // Place a Lottie JSON file here
import './rewardCard.css';

const RewardCard = ({
  title = '🎉 Reward Earned!',
  rewards = {},
  showConfetti = false,
  category = 'default',
}) => {
  const cardRef = useRef(null);
  const [animateIn, setAnimateIn] = useState(false);

  const { xp, jgk, streak, badge, message } = rewards;

  useEffect(() => {
    setAnimateIn(true);

    // Sound feedback
    if (showConfetti) {
      const audio = new Audio('/sounds/success-chime.mp3');
      audio.volume = 0.5;
      audio.play().catch(() => {});

      // Vibration feedback (mobile)
      if (window.navigator.vibrate) {
        window.navigator.vibrate(200);
      }
    }
  }, [showConfetti]);

  return (
    <div
      ref={cardRef}
      className={`reward-card world-class-card ${
        animateIn ? 'fade-slide-in' : ''
      }`}
    >
      {showConfetti && (
        <div className="confetti-anim-lottie">
          <Lottie
            animationData={confettiAnimation}
            loop={false}
            style={{ width: '100%', height: 120 }}
          />
        </div>
      )}
      <div
        className="reward-title"
        style={{ fontSize: 28, fontWeight: 700, marginBottom: 12 }}
      >
        {title}
      </div>
      <div className="reward-items">
        {typeof xp === 'number' && (
          <div className="reward-xp">
            <span role="img" aria-label="xp" className="reward-icon">
              ✨
            </span>
            <span className="reward-value">{xp}</span>
            <span className="reward-label">XP</span>
          </div>
        )}
        {typeof jgk === 'number' && (
          <div className="reward-jgk">
            <span role="img" aria-label="jgk" className="reward-icon">
              🪙
            </span>
            <span className="reward-value">{jgk}</span>
            <span className="reward-label">JGK</span>
          </div>
        )}
        {badge && (
          <div className="reward-badge">
            <span role="img" aria-label="badge" className="reward-icon">
              🏅
            </span>
            <span className="reward-value">{badge}</span>
            <span className="reward-label">Badge Unlocked!</span>
          </div>
        )}
        {typeof streak === 'number' && (
          <div className="reward-streak">
            <span role="img" aria-label="streak" className="reward-icon">
              🔥
            </span>
            <span className="reward-value">{streak}</span>
            <span className="reward-label">Day Streak</span>
          </div>
        )}
      </div>
      {message && (
        <div className="reward-message" style={{ marginTop: 10, fontSize: 16 }}>
          📣 {message}
        </div>
      )}
      {category && (
        <div
          className="reward-category"
          style={{ marginTop: 8, fontSize: 14, opacity: 0.8 }}
        >
          Category: {category}
        </div>
      )}
    </div>
  );
};
export default RewardCard;
